export const INPUT_TYPES = [
  "date",
  "decimal",
  "text",
  "number",
  "select",
  "alpha",
  "boolean",
];

export const Document_RequestType_None = 0;
export const VIEW_DOCUMENT_AND_METADATA = 1 << 0;
export const UPLOAD_DOCUMENT = 1 << 1;
export const IMPORT_DOCUMENT = 1 << 2;
export const DOWNLOAD_DOCUMENT = 1 << 3;
export const PRINT_DOCUMENT = 1 << 4;
export const DELETE_DOCUMENT = 1 << 5;
export const MODIFY_METADATA = 1 << 6;
export const VIEW_COMMENTS = 1 << 7;
export const MODIFY_COMMENTS = 1 << 8;
export const VIEW_LINE_DATAS = 1 << 9;
export const MODIFY_LINE_DATAS = 1 << 10;
export const MOVE_DOCUMENT = 1 << 11;
export const VIEW_AUDIT_OF_DOCUMENT = 1 << 12;
export const ARCHIVE_DOCUMENT = 1 << 13;
export const RESTORE_DOCUMENT = 1 << 14;
export const MARK_DOCUMENT_FOR_A_RETENTION_TYPE = 1 << 15;
export const HARD_DELETE_DOCUMENT = 1 << 16;
export const REVIVE_RETENTION_STATE = 1 << 17;
export const MATCH_DATA = 1 << 18;

export const SORT_ORDERS = { unsorted: 0, ascending: 1, descending: 2 };

export const RightOverlayProps = {
  placement: "right",
  delay: { show: 1000, hide: 75 },
};

export const LeftOverlayProps = {
  placement: "left",
  delay: { show: 1000, hide: 75 },
};

export const SUPPORTED_PDF_FILE_TYPES = ["application/pdf"];

export const SUPPORTED_IMAGE_FILE_TYPES = [
  "image/bmp",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/svg+xml",
];

export const SUPPORTED_MS_OFFICE_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.oasis.opendocument.spreadsheet",
];

export const SUPPORTED_PREVIEW_FILE_TYPES = [
  // TODO: Enable tiff images when DEV preview service issues resolved
  "image/tiff",
  "text/rtf",
  "application/vnd.oasis.opendocument.presentation",
  "application/vnd.oasis.opendocument.text",
];

export const matchContentTypes = {
  docx: "application/msword",
  doc: "application/msword",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.ms-excel",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.ms-powerpoint",
  bmp: "image/bmp",
  jpeg: "image/jpeg",
  jpg: "image/jpg",
  png: "image/png",
  gif: "image/gif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
};
export default {
  INPUT_TYPES,
  Document_RequestType_None,
  VIEW_DOCUMENT_AND_METADATA,
  UPLOAD_DOCUMENT,
  IMPORT_DOCUMENT,
  DOWNLOAD_DOCUMENT,
  PRINT_DOCUMENT,
  DELETE_DOCUMENT,
  MODIFY_METADATA,
  VIEW_COMMENTS,
  MODIFY_COMMENTS,
  VIEW_LINE_DATAS,
  MODIFY_LINE_DATAS,
  MOVE_DOCUMENT,
  VIEW_AUDIT_OF_DOCUMENT,
  ARCHIVE_DOCUMENT,
  RESTORE_DOCUMENT,
  MARK_DOCUMENT_FOR_A_RETENTION_TYPE,
  HARD_DELETE_DOCUMENT,
  REVIVE_RETENTION_STATE,
  MATCH_DATA,
  SORT_ORDERS,
  RightOverlayProps,
  LeftOverlayProps,
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
  matchContentTypes,
};
